// extracted by mini-css-extract-plugin
export default {"cls1":"MAH6ucIKfDJox1WQScGp","cls2":"diD43DHc56fiHasmnWFd MAH6ucIKfDJox1WQScGp","isPhone":"PLwKlYYJYs0HHyz3wMrY"};